import { Alert, Card, Tabs, Typography } from 'antd';
import InvestmentsTab from '../components/investor/InvestmentsTab';
import LedgerTab from '../components/investor/LedgerTab';
import MyDashboard from '../components/investor/MyDashboard';
import ProfileTab from '../components/investor/ProfileTab';
import ProfitTab from '../components/investor/ProfitTab';
import WithdrawalsTab from '../components/investor/WithdrawalsTab';
import { useAuth } from '../context/AuthContext';

/**
 * Read-only portfolio view for investor-role logins. The write buttons inside the shared tabs are
 * hidden by `canWrite`, and the API rejects investor writes regardless of what the UI shows.
 *
 * PDFs live in one place here: the Ledger tab's statement. The per-transaction receipt downloads
 * that staff see are hidden from investors, so there is a single, unambiguous document to take away
 * rather than the same figures scattered across four tabs.
 */
export default function InvestorPortalPage() {
  const { user } = useAuth();
  const investorId = user?.investorId ?? 0;

  if (!investorId) {
    return <Alert type="error" showIcon message="This account is not linked to an investor record." />;
  }

  return (
    <>
      <Typography.Title level={3}>My Portfolio</Typography.Title>

      <Card>
        <Tabs
          defaultActiveKey="overview"
          items={[
            { key: 'overview', label: 'Overview', children: <MyDashboard investorId={investorId} /> },
            { key: 'ledger', label: 'Ledger', children: <LedgerTab investorId={investorId} /> },
            { key: 'investments', label: 'My investments', children: <InvestmentsTab investorId={investorId} /> },
            { key: 'profit', label: 'Profit', children: <ProfitTab investorId={investorId} /> },
            { key: 'withdrawals', label: 'Withdrawals', children: <WithdrawalsTab investorId={investorId} /> },
            { key: 'profile', label: 'Profile', children: <ProfileTab investorId={investorId} /> },
          ]}
        />
      </Card>
    </>
  );
}
